import { render, staticRenderFns } from "./VButtonDropdownItems.vue?vue&type=template&id=28eb1a9d&functional=true&"
import script from "./VButtonDropdownItems.vue?vue&type=script&lang=ts&"
export * from "./VButtonDropdownItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports